import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb';
import { cn } from '@/lib/utils';

export type PageBreadcrumbItem = {
  label: string;
  href?: string;
};

interface PageBreadcrumbProps {
  items: PageBreadcrumbItem[];
  className?: string;
  /** Use on green/dark PageHero backgrounds */
  variant?: 'default' | 'onDark';
}

const PageBreadcrumb = ({
  items,
  className,
  variant = 'default',
}: PageBreadcrumbProps) => {
  if (!items.length) return null;

  const isOnDark = variant === 'onDark';

  return (
    <Breadcrumb className={className}>
      <BreadcrumbList
        className={cn(
          isOnDark && 'text-white/80 [&>li>svg]:text-white/60'
        )}
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <Fragment key={`${item.label}-${index}`}>
              {index > 0 && <BreadcrumbSeparator />}
              <BreadcrumbItem className="min-w-0">
                {isLast || !item.href ? (
                  <BreadcrumbPage
                    className={cn(
                      'truncate max-w-[12rem] sm:max-w-[20rem] md:max-w-md',
                      isOnDark && 'text-white font-medium'
                    )}
                  >
                    {item.label}
                  </BreadcrumbPage>
                ) : (
                  <BreadcrumbLink asChild>
                    <Link
                      to={item.href}
                      className={cn(
                        isOnDark && 'text-white/80 hover:text-white'
                      )}
                    >
                      {item.label}
                    </Link>
                  </BreadcrumbLink>
                )}
              </BreadcrumbItem>
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default PageBreadcrumb;
